import {makeObservable, set, runInAction, action, observable} from "mobx";

export default class UserSessionModel {
    checkServerTime!: Date;
    creationTime!: Date;
    maxInactiveInterval!: number;
    remainTime!: number;

    public constructor(data: {
        checkServerTime: Date;
        creationTime: Date;
        maxInactiveInterval: number;
        remainTime: number;
    }) {
        makeObservable(this, {
            checkServerTime: observable,
            creationTime: observable,
            maxInactiveInterval: observable,
            remainTime: observable,
            setCheckServerTime: action,
            setCreationTime: action,
            setMaxInactiveInterval: action,
            setRemainTime: action
        })
        set(this, data);
    }

    public setCheckServerTime(checkServerTime: Date) {
        this.checkServerTime = checkServerTime;
    }

    public setCreationTime(creationTime: Date) {
        this.creationTime = creationTime;
    }

    public setMaxInactiveInterval(maxInactiveInterval: number) {
        this.maxInactiveInterval = maxInactiveInterval;
    }

    public setRemainTime(remainTime: number) {
        this.remainTime = remainTime;
    }

    public decrement(decrement: number) {
        runInAction(() => {
            this.setRemainTime(this.maxInactiveInterval - decrement);
        });
    }
}
